// @ts-strict-ignore
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { UserSettings } from '@user/model/user-settings';
import { UserModel } from '@user/model/user.model';
import { UserUtils } from '@user/service/user-utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/custom-validators';

@Component({
  standalone: false,
  templateUrl: `./edit-notice.component.html`,
  selector: 'app-edit-notice',

})
export class EditNoticeComponent implements OnInit {

  @Output() public finish = new EventEmitter<void>();

  public hasEditPermission: boolean = false;
  public form: FormGroup;
  public showRequiredFields: boolean = false;

  constructor(
    private fb: FormBuilder,
    private bsModalRef: BsModalRef,
    private userSettings: UserSettings,
    private userModel: UserModel,
    private localeResourceManager: LocaleResourceManager
  ) { }

  ngOnInit(): void {
    this.hasEditPermission = UserUtils.hasEditProjectPermission(this.userModel.user);
    this.form = this.fb.group({
      noticeText: [
        this.getCurrentConfidentialNoticeText(),
        Validators.compose([
          CustomValidators.minMaxLength(0, 650, '', 'confidentialNoticeTextEditorPopup.error_tooLongError'),
          CustomValidators.trimRequired
        ])
      ]
    });
  }

  public checkControlValidity(controlName: string): boolean {
    const control = this.form.controls[controlName];
    return (control.invalid && control.touched) || (control.invalid && this.showRequiredFields);
  }

  private getDefaultConfidentialNoticeText(): string {
    return this.localeResourceManager.findValueByKey('documentation.confidential');
  }

  public getCurrentConfidentialNoticeText(): string {
    let result: string = this.getDefaultConfidentialNoticeText();
    const userSettingValue: string = this.userSettings.getUserSettingStringValue("confidentialNoticeText");
    if (userSettingValue) {
      result = userSettingValue;
    }
    return result;
  }

  public reset(): void {
    this.form.controls.noticeText.setValue(this.getDefaultConfidentialNoticeText());
  }

  public close(): void {
    this.bsModalRef.hide();
    this.finish.emit();
  }

  public save(): void {
    if (!this.form.valid) {
      this.showRequiredFields = true;
      return;
    }

    const newNoticeText: string = this.form.value.noticeText;
    this.userSettings.setUserSettingValue("confidentialNoticeText", newNoticeText);
    this.userSettings.saveUserSettings();
    this.close();
  }
}
